import { VList } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VList,_vm._g(_vm._b({attrs:{"expand":"","nav":""}},'v-list',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.items),function(item,i){return [(item.items)?_c('default-list-group',{key:`group-${i}`,style:([_vm.mini ? { 'background-color': 'rgba(0,0,0,0.6)', 'border-radius': '5px' } : {}]),attrs:{"item":item}}):_c('default-list-item',{key:`item-${i}`,attrs:{"item":item}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }